import React, { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ShoppingBag, X } from 'lucide-react';
interface Notice {
  name: string;
  location: string;
  timeAgo: string;
}
const NAMES = ['María José', 'Camila', 'Sofía', 'Lucía', 'Valentina', 'Daniela', 'Carolina', 'Julieta', 'Andrea', 'Gabriela', 'Paola', 'Fernanda', 'Martín', 'Lucas', 'Matías', 'Joaquín', 'Nicolás', 'Sebastián', 'Diego', 'Andrés', 'Santiago', 'Miguel', 'Carlos', 'Javier'];
const LOCATIONS = ['Ciudad de México, México', 'Guadalajara, México', 'Monterrey, México', 'Bogotá, Colombia', 'Medellín, Colombia', 'Cali, Colombia', 'Lima, Perú', 'Arequipa, Perú', 'Santiago, Chile', 'Valparaíso, Chile', 'Buenos Aires, Argentina', 'Córdoba, Argentina', 'Rosario, Argentina', 'Montevideo, Uruguay', 'Quito, Ecuador', 'Guayaquil, Ecuador', 'Asunción, Paraguay', 'La Paz, Bolivia', 'San José, Costa Rica', 'Ciudad de Panamá, Panamá', 'Santo Domingo, Rep. Dominicana', 'Madrid, España', 'Barcelona, España', 'Valencia, España'];
const TIME_PHRASES = ['hace unos minutos', 'hace 6 minutos', 'hace 12 minutos', 'hace 18 minutos', 'hace 25 minutos', 'hace 34 minutos'];
function pickRandom<T>(arr: T[]): T {
  return arr[Math.floor(Math.random() * arr.length)];
}
function buildNotice(): Notice {
  return {
    name: pickRandom(NAMES),
    location: pickRandom(LOCATIONS),
    timeAgo: pickRandom(TIME_PHRASES)
  };
}
export function PurchaseNotifications() {
  const [current, setCurrent] = useState<Notice | null>(null);
  const [visible, setVisible] = useState(false);
  useEffect(() => {
    let firstTimer: ReturnType<typeof setTimeout>;
    let hideTimer: ReturnType<typeof setTimeout>;
    let nextTimer: ReturnType<typeof setTimeout>;
    const cycle = () => {
      setCurrent(buildNotice());
      setVisible(true);
      // Visible for ~5s, then hide
      hideTimer = setTimeout(() => {
        setVisible(false);
        // Only after it closes, wait 18–26s before the next one
        nextTimer = setTimeout(cycle, 18000 + Math.random() * 8000);
      }, 5000);
    };

    // First notice never before 15s
    firstTimer = setTimeout(cycle, 16000);
    return () => {
      clearTimeout(firstTimer);
      clearTimeout(hideTimer);
      clearTimeout(nextTimer);
    };
  }, []);
  return <div className="fixed bottom-3 left-3 sm:bottom-5 sm:left-5 z-40 pointer-events-none" data-id="element-172" data-mp="31zrsbvjeq86c">
      <AnimatePresence data-id="element-173" data-mp="36rjhq2qtu7uw">
        {visible && current && <motion.div key={current.name + current.location + current.timeAgo} initial={{
        opacity: 0,
        x: -20
      }} animate={{
        opacity: 1,
        x: 0
      }} exit={{
        opacity: 0,
        x: -20
      }} transition={{
        duration: 0.22,
        ease: [0.23, 1, 0.32, 1]
      }} className="pointer-events-auto max-w-[255px] sm:max-w-[310px] bg-white border border-clinical-line shadow-[0_10px_28px_rgba(11,42,74,0.16)] rounded-2xl pl-2.5 pr-2 py-2 flex items-center gap-2.5" role="status" aria-live="polite" data-id="element-174" data-mp="36t4c9sd55qsr">
            <span className="flex-shrink-0 w-8 h-8 sm:w-9 sm:h-9 rounded-full bg-clinical-mist border border-clinical-line flex items-center justify-center" data-id="element-175" data-mp="28glf4vthu4a8">
              <ShoppingBag className="w-3.5 h-3.5 sm:w-4 sm:h-4 text-clinical-mid" strokeWidth={2.2} data-id="element-176" data-mp="2nbrq7x7g4taf" />
            </span>

            <div className="flex-1 min-w-0" data-id="element-177" data-mp="2w4uzdtb26jz9">
              <p className="text-[11.5px] sm:text-[12.5px] text-clinical-deep leading-tight" data-id="element-178" data-mp="2w7qwjff314mn">
                <span className="font-bold" data-id="element-179" data-mp="2s6fdjsqprhnf">{current.name}</span>
                <span className="text-clinical-ink/70" data-id="element-180" data-mp="364vknkshna63"> · </span>
                <span className="font-semibold" data-id="element-181" data-mp="31594b2hd5dt2">{current.location}</span>
              </p>
              <p className="text-[10.5px] sm:text-[11px] text-clinical-ink/70 leading-tight mt-0.5" data-id="element-182" data-mp="3l7di0unqwij9">
                accedió al Mega Pack {current.timeAgo}
              </p>
            </div>

            <button type="button" onClick={() => setVisible(false)} aria-label="Cerrar aviso" className="text-clinical-ink/30 hover:text-clinical-ink/70 transition-colors flex-shrink-0 p-1" data-id="element-183" data-mp="3tzffck2ipipb">
              <X className="w-3.5 h-3.5" data-id="element-184" data-mp="329u7tnpjwtv9" />
            </button>
          </motion.div>}
      </AnimatePresence>
    </div>;
}